// OSS存储
export default {
  // 图片URL路径
  path: process.env.NODE_ENV === 'productioncom' ?
    'http://hz9idesk-oss.oss-cn-hangzhou.aliyuncs.com/' :
    'http://hz9idesktest-oss.oss-cn-hangzhou.aliyuncs.com/',

  // 生成文件名
  getImgName(file) {
    const suffix = file.name.split('.').pop().toLowerCase();
    return {
      name: new Date().getTime() + Math.random().toString(36).substr(2) + '.' + suffix,
      suffix
    }
  },
  // 桌面推送
  recommendIcon: 'official_resource/recommend/icon/',
  // 9i推送
  '9irecommend': 'official_resource/recommend/icon/',
  // 9i弹窗推送
  taskRecommendPic: 'official_resource/task_recommend/pic/',
  // 9i应用库
  storePic: 'official_resource/store/pic/',
  // 9i图标资源
  baseIcon: 'official_resource/base/icon/',
  // 9i壁纸资源
  baseWallpaper: 'official_resource/base/wallpaper/',
  // 商品资源
  goodsPic: 'official_resource/goods/pic/',
  // 广告相关
  adverPic: 'official_resource/app_recommend/pic',
  // APP任务
  appTask: 'resource/app/task'

}



// WEBPACK FOOTER //
// ./src/utility/ossImgUrl.js